module.exports = __webpack_public_path__ + "static/media/signup-log.e0ef67f6.jpg";